import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import {
    getHTMLStringNumber,
    getNumberFormat,
    getNumberFormatLocale,
} from 'libs/ng-common-lib/src/utilities/numberAndCurrencyUtility';
import { WholesaleCurrencyNumberConfigToken } from '../provider/currency.provider';

@Pipe({
    name: 'wholesaleNumberHtml',
    standalone: true,
})
export class WholesaleNumberHtmlPipe implements PipeTransform {
    protected readonly currencyNumberConfig = inject(WholesaleCurrencyNumberConfigToken);

    transform(value: number | string | undefined | null, lang = 'de', digits = 0): string {
        if (!value || value === 0 || typeof value !== 'number') {
            return value ? value.toString() : '';
        }

        const numberFormatLocale = getNumberFormatLocale(lang, this.currencyNumberConfig);
        const numberFormat = getNumberFormat(numberFormatLocale, digits);

        const valueParts = numberFormat.format(value);
        return getHTMLStringNumber(valueParts, lang, digits, this.currencyNumberConfig);
    }
}
